/**
 * Utility module for Loop Returns OnStore
 *
 * Documentation:
 *  - https://help.loopreturns.com/en/articles/1917761#set_up_shop_now_on_store
 *
 */

/**
 * Check if Loop Returns OnStore is enabled
 *
 * @returns {boolean}
 */
const isEnabled = () => window?.ALLBIRDS?.settings?.loopReturnsOnstore?.enabled || false;

/**
 * Check if Loop Returns OnStore is active
 *
 * @returns {boolean}
 */
const isActive = () => isEnabled() && window?.LoopOnstore?.isActive();

export { isActive, isEnabled };
